module.exports = __webpack_public_path__ + "static/ui-docs-icon-8cb223de0d3898518994a1a93836b23e.svg";